/**
 * Corps des modifications d'équipe (M7, module `roles-fins` et cœur `equipe`).
 *
 * `revision` : la révision d'équipe lue par `GET …/equipe`. Facultative pour un
 * appel direct ; la régie l'envoie toujours (409 `revision_equipe_perimee`).
 */
import { z } from 'zod';
import { roleGalerieSchema } from '../permissions/roles.js';
const revisionSchema = z.number().int().min(0);
export const modificationRoleSchema = z.strictObject({
    role: roleGalerieSchema,
    revision: revisionSchema.optional(),
});
/** Les quatre droits, tous présents : on remplace l'ensemble, jamais une partie. */
export const droitsFinsCompletsSchema = z.strictObject({
    voirPrixArtiste: z.boolean(),
    coffreConfidentiel: z.boolean(),
    emettreFactures: z.boolean(),
    publierSite: z.boolean(),
});
export const modificationDroitsSchema = z.strictObject({
    droits: droitsFinsCompletsSchema,
    revision: revisionSchema.optional(),
});
//# sourceMappingURL=equipe.js.map